// src/assets/logoMap.js
import irisLogoWithName from './images/iris-logo-with-name.jpeg'
import irisLogo from './images/iris-health-logo.jpeg'

import trilliumLogoWithName from './Trillium-health-logo.png'
import trilliumLogo from './trillium-logo.svg'

export const logoMap = {
  iris: {
    logo: irisLogo,
    logoWithName: irisLogoWithName,
  },
  trillium: {
    logo: trilliumLogo,
    logoWithName: trilliumLogoWithName,
  },
  primrose: {
    logo: '',
    logoWithName: '',
  },
}
